import { useQuery } from '@tanstack/react-query';

import { MetadataClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetAuthorizedForms() {
  return useQuery({
    queryKey: [queryKeys.Metadata.AuthorizedForms],
    queryFn: () => metadataClient.getAuthorizedForms(),
    staleTime: 5 * 60 * 1000,
  });
}

export default useGetAuthorizedForms;
